module.exports = __webpack_public_path__ + "img/fern-win.d6a523fb.png";